import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { http, setUnauthorizedHandler } from '../services/http';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const response = await http('/api/auth/me/', { skipAuthRedirect: true });
      const nextUser = response.ok ? await response.json() : null;
      setUser(nextUser);
      return nextUser;
    } catch (error) {
      console.error('Не удалось получить текущего пользователя:', error);
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(null));
    refresh();
    return () => setUnauthorizedHandler(null);
  }, [refresh]);

  const login = useCallback(() => refresh(), [refresh]);

  const logout = useCallback(async () => {
    try {
      await http('/api/auth/logout/', { method: 'POST' });
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    } finally {
      setUser(null);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth должен использоваться внутри AuthProvider');
  }
  return context;
};

export default AuthContext;
